import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../brand-colors';

function BrandEngineer() {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Brand Kit',
      icon: '\uD83C\uDFA8',
      description: 'Your brand colors, fonts, logos, icons, and design assets in one place.',
      path: '/command-center/brand-engineer/brand-kit',
      buttonText: 'Open Brand Kit',
      color: colors.goldMid
    },
    {
      title: 'Brand Strategy Guide',
      icon: '\uD83D\uDCD6',
      description: 'Your complete AI-generated brand strategy guide with 20+ sections covering positioning, messaging, and visual identity.',
      path: '/command-center/brand-engineer/brand-strategy-guide',
      buttonText: 'Open Strategy Guide',
      color: colors.navy
    },
    {
      title: 'Marketing Execution Playbook',
      description: 'Your production standards for consistent, on-brand marketing execution across every channel and content type.',
      path: '/command-center/brand-engineer/brand-playbook',
      buttonText: 'Open Playbook',
      color: colors.goldDark
    }
  ];

  return (
    <Container className="py-4">
      <div className="mb-4">
        <h1 style={{
          fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
          letterSpacing: '0.15em',
        }}>Brand Engineer</h1>
        <p className="text-muted">
          Build and manage your complete brand identity — from visual assets to strategic positioning.
        </p>
      </div>

      <Row>
        {cards.map((card) => (
          <Col key={card.title} lg={6} className="mb-4">
            <Card
              className="h-100 shadow-sm"
              style={{
                border: `1px solid ${colors.greyLight}`,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onClick={() => navigate(card.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = colors.goldMid;
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = colors.greyLight;
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <Card.Header style={{
                backgroundColor: colors.greyDarkest,
                color: colors.goldLight,
                fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
                letterSpacing: '0.1em',
              }}>
                <strong>{card.title}</strong>
              </Card.Header>
              <Card.Body className="d-flex flex-column p-4">
                <p className="text-muted flex-grow-1">{card.description}</p>
                <Button
                  variant="outline-dark"
                  className="mt-auto"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(card.path);
                  }}
                >
                  Open {card.title} →
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default BrandEngineer;
